window.VegasOrder = {
	updateTotals: function () {
		let params = $("#form-order").serializeArray();

		$.get('/cart/order/totals', params, function (data) {
			let $containerTotals = $('.vg-shop-order--total');
			$containerTotals.after(data.view_totals);
			$containerTotals.remove();

			let $containerProducts = $('.vg-shop-order--products');
			$containerProducts.after(data.view_products);
			$containerProducts.remove();
			$('.vg-shop-order--products [data-bs-toggle="tooltip"]').tooltip();

			if (data.discounts_changed) {
				alert('Сумма скидок по акциям была изменена. Проверьте сумму заказа.');
			}
		});
	},
};

$(document).ready(function () {
	let $formOrder = $("#form-order");

	$formOrder.find('[data-toggle=delivery]').on('change', function () {
		let delivery = $(this).val();
		let $container = $(this).closest('.vg-shop-order--block');

		$formOrder.find('.vg-shop-order--block-delivery').removeClass('checked');
		let $activeDelivery = $formOrder.find('.vg-shop-order--block-delivery[data-delivery="' + delivery + '"]');
		$activeDelivery.addClass('checked');

		$formOrder.find('[data-required]').removeAttr('required');
		$activeDelivery.find('[data-required]').each(function () {
			$(this).attr('required', 'required');
		});

		VegasOrder.updateTotals();

		return false;
	});

	$formOrder.find('[data-toggle=delivery]:checked').trigger('change');

	$formOrder.find('.delivery-area').change(function () {
		let i = $(this).val();

		$formOrder.find('.delivery-info .delivery').hide();
		$formOrder.find('.delivery-info .delivery[data-index="' + i + '"]').show();

		VegasOrder.updateTotals();
	});

	let $inputBonus = $('#cart-use-bonus');
	let $sliderBonus = $('.range-slider-bonus');

	let timeoutCartUseBonus;
	$inputBonus.on('update', function () {
		clearTimeout(timeoutCartUseBonus);
		timeoutCartUseBonus = setTimeout(function () {
			VegasOrder.updateTotals();
		}, 100);
	});

	$sliderBonus.ionRangeSlider({
		skin: "round",
		onChange: function (data) {
			$inputBonus.val(data.from).trigger('update');
		}
	});

	let $slider = $sliderBonus.data("ionRangeSlider");

	$inputBonus.on('input', function () {
		let $self = $(this),
			val = parseInt($self.val()) || null,
			max = parseInt($self.attr('max')) || null;

		if (val && max) {
			if (val > max) {
				val = max;
				$self.val(val)
			}
		}

		$slider.update({
			from: val
		});

		$(this).trigger('update');
	});

	$formOrder.on('submit', function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		let $loader = $("#order-loader");

		$loader.show();

		$.post(route, params, function (data) {
			$loader.hide();

			if (data.error) {
				alert(data.msg || 'При оформлении заказа произошла ошибка. Попробуйте еще раз!');
			} else {
				if (data.redirect_to) {
					location.href = data.redirect_to;
				}
			}
		});

		return false;
	});

	$formOrder.find('[data-toggle=payment]').on('change', function () {
		let payment = $(this).val();

		$formOrder.find('.vg-shop-order--block-payment').removeClass('checked');
		let $activeDelivery = $formOrder.find('.vg-shop-order--block-payment[data-payment="' + payment + '"]');
		$activeDelivery.addClass('checked');

		return false;
	});

	let $selectAddress = $formOrder.find('[name=user_address]');
	let $area = $formOrder.find('select.delivery-area');
	if ($selectAddress.length) {
		$selectAddress.select2({
			language: 'ru',
			ajax: {
				url: $selectAddress.data('ajaxurl'),
				data: function (params) {
					let query = {
						search: params.term,
						city: {
							title: $selectAddress.data('city_title'),
							id: $selectAddress.data('city_id'),
						},
						area: $area.find('option:selected').text(),
					};

					return query;
				}
			},
			processResults: function (data) {
				return {
					results: data.items
				};
			}
		}).on('select2:select', function (e) {
			let d = e.params.data;
			let $delivery = $(this).closest('.vg-shop-order--block-delivery')
			$delivery.find('[data-segment]').val('');

			for(let segmentName in d.segments) {
				if (typeof d.segments[segmentName] !== 'undefined') {
					$delivery.find(`[data-segment=${segmentName}]`).val(d.segments[segmentName]);
				}
			}
		});

		$selectAddress.data('select2').$dropdown.find(':input.select2-search__field').attr('placeholder', $selectAddress.data('placeholder-search'));
	}
});
